import "./aboutWebsite.css";
const AboutWebsite = () => {
  return (
    <section className="py-5" data-aos="zoom-in">
      <div className="container">
        <div className="row page-heading2">
          <p className="page-head">ABOUT WEBSITE</p>
        </div>
        <div>
        <div className="fs-4" >About Snehita Well Being Website</div>
        <br/>
         The Snehita Well Being Website serves as a
          comprehensive counseling platform offering features such as well-being
          fun quizzes, informative blogs and articles, easy appointment
          scheduling, and direct contact points for students seeking support. It
          is designed to promote mental health awareness and provide resources
          for students to prioritize their well-being while navigating the
          challenges of academic life.
          <br />
          <br />
          <div className="fs-4" >Website Development Team</div>
          <br />
          <ul>
            <li>Nikhil Garg (2021CSB1114)</li>
            <li>Khushboo Gupta (2021CSB1105)</li>
            <li>Piyush Kumar (2021CSB1123)</li>
            <li>Manav Chauhan (2021CSB1108)</li>
          </ul>
          <div className="fs-4" >Project Mentor</div>
          <br />
          <ul>
            <li>Mr. Deepak Phogat (Cousellor, Snehita Well Being)</li>
            <li>Dr. Parwinder Singh (Faculty Advisor, Snehita Well Being)</li>
            <li>Dr. Puneet Goyal (Faculty CSE)</li>
          </ul>
          <div className="fs-4" >Course Mentor</div>
          <br />
          <ul>
            <li>Dr. Puneet Goyal (Faculty CSE)</li>
            <li>Dr. Geeta Yadav (Faculty CSE)</li>
          </ul>
          <div className="fs-4" >Project Overview</div>
          <br />
          The Snehita Well Being Website was conceived as part of the CP301
          project to address the growing need for mental health resources and
          support within the IIT Ropar community. Through collaborative efforts
          and guidance from our mentors, the project team worked diligently to
          create a user-friendly platform offering various features to enhance
          student well-being.
          <br />
          <br />
          <div className="fs-4" >Acknowledgements</div>
          <br/>
           We extend our heartfelt gratitude to all those who
          contributed to the development of the Snehita Well Being Website
          <br />
          <br />
            Our project mentors, Dr. Puneet Goyal for his guidance and mentorship throughout the development of this project. 
            <br/>
            <br/>

            Special thanks to Dean Student Affairs Dr. Puneet Pasricha, Mr. Deepak Phogat, Ms. Gargi, Ms. Kajal, Ms. Priyanka, Dr. Satyam Agarwal and Dr. Parwinder Singh for their valuable insights and support.
          <br />
          <br />
          The counseling team and Snehita buddies for their collaboration and
          insights into student well-being needs.

        </div>
      </div>
    </section>
  );
};
export default AboutWebsite;
